module.exports = __webpack_public_path__ + "img/type10010.a3c3c8ff.png";